import React, { Component } from "react";

import {
  authErrorMessages,
  requestPasswordResetInstructions,
} from "../services/backendRequests";
import { AuthShell } from "../landing/AuthShell";
import { InlineSpinner } from "../components/InlineSpinner";
import { Link } from "react-router-dom";
import _ from "lodash";

class AskPasswordReset extends Component {
  constructor(props) {
    super(props);
    this.email = React.createRef();
    this.state = {
      submitting: false,
      resetRequestStatus: {},
    };
  }

  onEmailSubmission(event) {
    event.preventDefault();
    this.setState({ submitting: true });
    const started = Date.now();

    requestPasswordResetInstructions(this.email.current.value)
      .then((response) => this.setState({ resetRequestStatus: response }))
      .catch((err) =>
        this.setState({
          resetRequestStatus: { success: false, errors: [err.message] },
        })
      )
      .finally(() => {
        // Same parti pris as the login form: hold the spinner 400ms minimum so a
        // near-instant response still registers.
        const wait = Math.max(0, 400 - (Date.now() - started));
        setTimeout(() => this.setState({ submitting: false }), wait);
      });
  }

  displayRequestStatus() {
    const status = this.state.resetRequestStatus;
    if (_.isEmpty(status)) return null;

    const message = status.success
      ? status.message
      : status.statusText || authErrorMessages(status.errors).join(" ");

    return (
      <div className={status.success ? "lg-success" : "lg-error"} role="alert">
        {message}
      </div>
    );
  }

  render() {
    return (
      <AuthShell title="Reset your password">
        <form
          className="lg-form"
          onSubmit={(event) => this.onEmailSubmission(event)}
        >
          {this.displayRequestStatus()}

          <div className="lg-field">
            <label htmlFor="reset-email">Email</label>
            <input
              id="reset-email"
              name="email"
              type="email"
              placeholder="you@company.com"
              ref={this.email}
              autoComplete="email"
              required
            />
          </div>

          <button
            className="lg-submit"
            type="submit"
            disabled={this.state.submitting}
          >
            {this.state.submitting ? (
              <>
                <InlineSpinner /> Sending...
              </>
            ) : (
              "Send reset link"
            )}
          </button>

          <Link className="lg-forgot" to="/">
            Back to login
          </Link>
        </form>
      </AuthShell>
    );
  }
}

export default AskPasswordReset;
